"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = getAuthHeaders;
const log_1 = require("../../log");
const log = (0, log_1.getLog)(module);
/**
 * Gets auth headers for a TokenResult, or undefined if no token is available.
 * @param tokenResult the token result
 * @param userType the user type
 */
function getAuthHeaders(tokenResult, userType) {
    const headers = {};
    if ((tokenResult === null || tokenResult === void 0 ? void 0 : tokenResult.headerName) && (tokenResult === null || tokenResult === void 0 ? void 0 : tokenResult.token)) {
        headers[tokenResult.headerName] = tokenResult.token;
    }
    if (userType) {
        headers['kh-impersonated-user-type'] = userType;
    }
    log.trace('Auth headers: %O', headers);
    if (Object.keys(headers).length === 0) {
        return undefined;
    }
    return headers;
}
//# sourceMappingURL=AuthHeaderHelper.js.map